<template>
  <div class="product-container">
<!--    <nav class="nav-header">-->
<!--      &lt;!&ndash; <p @click="$router.push({name: 'company-admin-campaings-dashboard'})"-->
<!--         :class="($route.name === 'company-admin-campaings-dashboard') ? 'active' : ''">Dashboard</p> &ndash;&gt;-->
<!--      <p @click="$router.push({name: 'company-admin-campaings-all-campaings'})"-->
<!--         :class="($route.name === 'company-admin-campaings-all-campaings'-->
<!--          || $route.name === 'company-admin-campaings-add-campaing'-->
<!--          || $route.name === 'company-admin-campaings-edit-campaing') ? 'active' : ''">All Campaigns</p>-->
<!--      <p @click="$router.push({name: 'company-admin-campaings-keyword-manager'})"-->
<!--         :class="($route.name === 'company-admin-campaings-keyword-manager'-->
<!--          || $route.name === 'company-admin-campaings-add-keyword'-->
<!--          || $route.name === 'company-admin-campaings-edit-keyword') ? 'active' : ''">Keyword Manager</p>-->
<!--      <p @click="$router.push({name: 'company-admin-campaings-ani-groups'})"-->
<!--         :class="($route.name === 'company-admin-campaings-ani-groups'-->
<!--         || $route.name === 'company-admin-campaings-add-ani-group'-->
<!--         || $route.name === 'company-admin-campaings-import-ani-group') ? 'active' : ''">Ani Group</p>-->
<!--    </nav>-->
    <router-view class="router-container" />

  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.product-container {
  .nav-header {
    height: 50px;
    background-color: #fff;
    padding: 0px 15px 0px 15px;
    display: flex;
    p {
      cursor: pointer;
      height: calc(100% - 2px);
      display: flex;
      align-items: center;
      padding: 0px 5px 0px 5px;
      margin-bottom: 0;
      color: #bdbfd8;
      font-family: ""Helvetica Neue"";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      text-align: center;
    }
    .active {
      color: #51a3f3;
      border-bottom: 2px solid #51a3f3;
    }
  }
  .router-container {
    padding: 0 20px;
  }
}
</style>

